/* ============================================================
   PLENNIA MOBILE ENHANCEMENTS (JS) — added 2026-08-07 (v2)
   Runs ONLY below 750px (guarded at the top), so desktop
   behaviour is completely untouched. Loaded from the footer
   section next to plennia-mobile.css.
   1) Hamburger menu: expandable "Shop" categories (cloned from
      the footer link columns — correct EN/ES + URLs).
   2) PDP: fold "Main ingredients" + bag calculator into
      tap-to-open accordions.
   3) PDP sticky bar: add a "Buy once" button next to Subscribe.
   4) Homepage: floating Tailor-Made plan pill (one-tap quiz).
   5) PDP gallery: swipeable slides with dots (2+ images only).
   ============================================================ */
(function () {
  'use strict';
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var isEs = (document.documentElement.lang || '').indexOf('es') === 0;

  /* ---------- 1. Shop categories in the mobile drawer ---------- */
  function buildDrawerCategories() {
    var panel = document.querySelector('.plennia-header__mobile-panel');
    if (!panel || panel.querySelector('.plennia-mdrawer-sub')) return;

    var anchors = panel.querySelectorAll('ul li a');
    var shopA = null;
    for (var i = 0; i < anchors.length; i++) {
      var t = anchors[i].textContent.trim().toLowerCase();
      var href = anchors[i].getAttribute('href') || '';
      if (t === 'shop' || t === 'tienda' || href.indexOf('/collections/all') !== -1) { shopA = anchors[i]; break; }
    }
    if (!shopA) return;

    var cols = document.querySelectorAll('.plennia-footer__column');
    if (cols.length < 2) return;

    var sub = document.createElement('div');
    sub.className = 'plennia-mdrawer-sub';
    sub.hidden = true;

    var all = document.createElement('a');
    all.href = shopA.getAttribute('href') || ((isEs ? '/es' : '') + '/collections/all');
    all.textContent = isEs ? 'Todos los productos' : 'All products';
    sub.appendChild(all);

    [cols[0], cols[1]].forEach(function (col) {
      var h = col.querySelector('h2');
      var head = document.createElement('p');
      head.className = 'plennia-mdrawer-sub__head';
      head.textContent = h ? h.textContent.trim() : '';
      sub.appendChild(head);
      var links = col.querySelectorAll('ul a');
      for (var j = 0; j < links.length; j++) {
        var c = document.createElement('a');
        c.href = links[j].getAttribute('href');
        c.textContent = links[j].textContent.trim();
        sub.appendChild(c);
      }
    });

    var li = shopA.closest('li');
    li.appendChild(sub);

    var caret = document.createElement('span');
    caret.className = 'plennia-mdrawer-caret';
    caret.setAttribute('aria-hidden', 'true');
    shopA.appendChild(caret);
    shopA.setAttribute('role', 'button');
    shopA.setAttribute('aria-expanded', 'false');

    shopA.addEventListener('click', function (e) {
      e.preventDefault();
      var open = sub.hidden;
      sub.hidden = !open;
      li.classList.toggle('is-open', open);
      shopA.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- 2. PDP: fold long sections into accordions ---------- */
  function foldSection(sel, fallbackLabel) {
    var el = document.querySelector(sel);
    if (!el || el.querySelector('.plennia-macc')) return;
    var h = el.querySelector('h2, h3');
    var label = h ? h.textContent.trim() : fallbackLabel;

    var det = document.createElement('details');
    det.className = 'plennia-macc';
    var sum = document.createElement('summary');
    sum.textContent = label;
    det.appendChild(sum);
    while (el.firstChild) det.appendChild(el.firstChild);
    el.appendChild(det);
  }

  /* ---------- 3. Sticky bar: "Buy once" second button ---------- */
  function initStickyBuyOnce() {
    var sticky = document.querySelector('.plennia-pdp__sticky');
    var addBtn = sticky && sticky.querySelector('[data-sticky-add]');
    var onceCard = document.querySelector('.pdp3-plan--once');
    if (!sticky || !addBtn || !onceCard || sticky.querySelector('.plennia-sticky-once')) return false;

    var m = (onceCard.textContent || '').match(/(\d+[.,]\d{2})\s*€/);
    var price = m ? m[1] + ' €' : '';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'plennia-sticky-once';
    btn.textContent = (isEs ? 'Compra única' : 'Buy once') + (price ? ' · ' + price : '');
    btn.addEventListener('click', function () {
      onceCard.click();
      setTimeout(function () { addBtn.click(); }, 180);
    });
    sticky.insertBefore(btn, addBtn);
    return true;
  }

  /* ---------- 4. Homepage: one-tap quiz pill ---------- */
  function initQuizPill() {
    if (!document.body.classList.contains('template-index')) return;
    if (document.querySelector('.plennia-quiz-pill')) return;
    var a = document.createElement('a');
    a.className = 'plennia-quiz-pill';
    a.href = (isEs ? '/es' : '') + '/pages/plan';
    a.textContent = isEs ? 'Plan a medida' : 'Tailor-Made plan';
    document.body.appendChild(a);
  }

  /* ---------- 5. PDP gallery: swipeable slides + dots ---------- */
  function initSwipeGallery() {
    var stage = document.querySelector('.plennia-pdp__stage');
    var main = document.querySelector('.plennia-pdp__img');
    if (!stage || !main || document.querySelector('.plennia-swipe')) return;

    var srcs = [];
    var push = function (src) {
      if (!src) return;
      src = src.replace(/width=\d+/, 'width=900');
      if (srcs.indexOf(src) === -1) srcs.push(src);
    };
    push(main.currentSrc || main.src);
    document.querySelectorAll('.plennia-pdp__strip img').forEach(function (i) { push(i.currentSrc || i.src); });
    if (srcs.length < 2) return; /* one photo — nothing to swipe */

    var wrap = document.createElement('div');
    wrap.className = 'plennia-swipe';
    srcs.forEach(function (s) {
      var sl = document.createElement('div');
      sl.className = 'plennia-swipe__slide';
      var im = document.createElement('img');
      im.src = s;
      im.loading = 'lazy';
      im.alt = main.alt || '';
      sl.appendChild(im);
      wrap.appendChild(sl);
    });
    var dots = document.createElement('div');
    dots.className = 'plennia-swipe__dots';
    srcs.forEach(function (_, i) {
      var dt = document.createElement('span');
      if (i === 0) dt.className = 'is-on';
      dots.appendChild(dt);
    });
    wrap.addEventListener('scroll', function () {
      var i = Math.round(wrap.scrollLeft / Math.max(1, wrap.clientWidth));
      for (var j = 0; j < dots.children.length; j++) dots.children[j].classList.toggle('is-on', j === i);
    }, { passive: true });

    stage.replaceChildren(wrap, dots);
    var strip = document.querySelector('.plennia-pdp__strip');
    if (strip) strip.style.display = 'none';
  }

  function initPdp() {
    if (!document.body.classList.contains('template-product')) return;
    foldSection('.plennia-pdp__ingwrap', isEs ? 'Ingredientes principales' : 'Main ingredients');
    foldSection('.plennia-pdp__calc', isEs ? '¿Cuánto dura una bolsa?' : 'How long will a bag last?');
    initSwipeGallery();
    /* plan cards render async — retry until present (max ~6s) */
    if (!initStickyBuyOnce()) {
      var tries = 0;
      var t = setInterval(function () {
        if (initStickyBuyOnce() || ++tries > 20) clearInterval(t);
      }, 300);
    }
  }

  function initAll() { buildDrawerCategories(); initQuizPill(); initPdp(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
